var map = {
	"./alert.svg": "1540",
	"./alias.svg": "17d9",
	"./analogo.svg": "4f9d",
	"./bluetooth_off.svg": "672d",
	"./bluetooth_on.svg": "d686",
	"./cpu.svg": "38fe",
	"./digital.svg": "123b",
	"./gas.svg": "856f",
	"./home-device-icon.svg": "de29",
	"./nfc_off.svg": "b673",
	"./nfc_on.svg": "5e19",
	"./notification.svg": "b17b",
	"./spore_icon.svg": "31b1",
	"./statistics.svg": "7a7b",
	"./tick-icon.svg": "68f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0bd";